import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=543dbf68&scoped=true&"
import script from "./newsCenter.vue?vue&type=script&lang=js&"
export * from "./newsCenter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./newsCenter.vue?vue&type=style&index=0&id=543dbf68&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "543dbf68",
  "ae4ceb42"
  
)

export default component.exports